// userLookup.services.js
import axios from 'axios';
import logger from '../utils/logger';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const userLookupService = {
  getUserByEmail: async (email) => {
    try {
      const apiUrl = `${BASE_URL}/company/detail/user/${encodeURIComponent(email)}`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      logger.error('userLookupService (ERROR): getUserByEmail ', error.message);
      throw error;
    }
  },

  getUserById: async (userid) => {
    try {
      const apiUrl = `${BASE_URL}/company/detail/userid/${encodeURIComponent(userid)}`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      logger.error('userLookupService (ERROR): getUserById ', error.message);
      throw error;
    }
  },
};

export default userLookupService;
